import { UploadOutlined } from "@ant-design/icons";
import { Button, Form, Input, Upload, message } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import React from "react";
import { MyModal } from "../../../components/styled-components";
import { POST } from "../../../services";
import { CHECKER_FIX_FILE } from "../../../services/path";

interface UploadModalProps {
  visible: boolean;
  onClose: () => void;
}

const ModalUploadFile: React.FC<UploadModalProps> = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const normFile = (e: any): UploadFile[] | undefined => {
    if (Array.isArray(e)) {
      return e;
    }

    return e?.fileList;
  };

  const onFinish = async (values: any) => {
    const headers = {
      "Content-Type": "multipart/form-data",
    };

    const formData = new FormData();
    formData.append("order_no", values.order_no);
    formData.append("tracking_no", values.tracking_no);

    // Assuming only one file is uploaded
    if (values.upload && values.upload.length > 0) {
      formData.append("file", values.upload[0].originFileObj);
    }

    try {
      const response = await POST(CHECKER_FIX_FILE, formData, headers);
      if (response !== null) {
        message.success("File uploaded successfully");
        form.resetFields();
      } else {
        message.error("Upload failed");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("An error occurred");
    }
  };

  return (
    <MyModal title="Upload File" visible={visible} onOk={onClose} onCancel={onClose} footer={null}>
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="upload" valuePropName="fileList" getValueFromEvent={normFile}>
          <Upload name="file" listType="text" beforeUpload={() => false}>
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </Form.Item>
        <Form.Item
          name="order_no"
          rules={[{ required: true, message: "Please input your order number!" }]}
        >
          <Input placeholder="Order No" />
        </Form.Item>
        <Form.Item
          name="tracking_no"
          rules={[{ required: true, message: "Please input your tracking number!" }]}
        >
          <Input placeholder="Tracking No" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Upload
          </Button>
        </Form.Item>
      </Form>
    </MyModal>
  );
};

export default ModalUploadFile;
